export enum ContactsTableActionType {
  Delete = 'delete',
  Edit = 'edit',
}
